import React, { Component } from "react";
import * as THREE from "three";
// import { GUI } from "three/examples/jsm/libs/dat.gui.module.js";
import { OrbitControls } from "three/examples/jsm/controls/OrbitControls";
// import { RoughnessMipmapper } from "three/examples/jsm/loaders/EXRLoader.js";
// import { EXRLoader } from "three/examples/jsm/utils/RoughnessMipmapper.js";
import { RoomEnvironment } from "three/examples/jsm/environments/RoomEnvironment.js";
//
// import { RGBELoader } from "three/examples/jsm/loaders/RGBELoader";
//
// https://threejsfundamentals.org/threejs/lessons/threejs-lights.html
// import { RectAreaLightHelper } from "three/examples/jsm/helpers/RectAreaLightHelper.js";
import { RectAreaLightUniformsLib } from "three/examples/jsm/lights/RectAreaLightUniformsLib.js";

import { GLTFLoader } from "three/examples/jsm/loaders/GLTFLoader";
import { DRACOLoader } from "three/examples/jsm/loaders/DRACOLoader";

// const style = {
//   height: 600, // we can control scene size by setting container dimensions

// };
//
//examples/js/lights/RectAreaLightUniformsLib.js
//

//
//

class FurnitureThreeScene extends Component {
  // Creating the set interval function that i will use in the lights TEST
  // 1 set interval related: create the state to define a base number/seconds
  // state = {
  //   seconds: 1,
  // };
  //
  //
  //
  componentDidMount() {
    this.sceneSetup();
    this.addCustomSceneObjects();
    RectAreaLightUniformsLib.init();
    //
    this.startAnimationLoop();
    window.addEventListener("resize", this.handleWindowResize);
    //
    //
  }
  //
  //
  componentWillUnmount() {
    window.removeEventListener("resize", this.handleWindowResize);
    window.cancelAnimationFrame(this.requestID);

    //
    // CLEAN UP
    //
    //
    /*
    Three.js apps often use lots of memory. A 3D model might be 1 to 20 meg memory for all of its vertices. A model might use many textures that even if they are compressed into jpg files they have to be expanded to their uncompressed form to use. Each 1024x1024 texture takes 4 to 6meg of memory.

Most three.js apps load resources at init time and then use those resources forever until the page is closed. But, what if you want to load and change resources over time?

Unlike most JavaScript, three.js can not automatically clean these resources up. The browser will clean them up if you switch pages but otherwise it's up to you to manage them. This is an issue of how WebGL is designed and so three.js has no recourse but to pass on the responsibility to free resources back to you.

You free three.js resource this by calling the dispose function on textures, geometries, and materials.

https://threejsfundamentals.org/threejs/lessons/threejs-cleanup.html

 
     */

    this.controls.dispose();

    //

    this.textiCubeEnvBridge.dispose();

    this.SteelBridgeMat.dispose();

    // this.bodyCroco.dispose();
    // this.crocoMat.dispose();
    // for performance issues add the dispose() to anything containing an image.
    this.bodyCroco.dispose();
    this.crocoMatPhysical.dispose();
    this.planeGeometry.dispose();
    // this.matTranspmaterial.dispose();
    // this.planeMesh.dispose();
    // lights
    this.light.dispose();
    this.light2.dispose();
    this.light3.dispose();
    this.light4.dispose();
    this.SecondHemLight.dispose();
    this.lightRectArea.dispose();
    this.spotLight.dispose();
  }

  // 1
  sceneSetup = () => {
    //                WIDTH/HEIGHT
    // --------------------------------------------
    //
    const width = this.monteCacaoOne.clientWidth;
    const height = this.monteCacaoOne.clientHeight;
    //
    // --------------------------------------------
    //
    //
    // ---------------
    // Create a camera
    // ---------------
    //https://observablehq.com/@severo/three-js-perspective-camera-utils
    // 	Set a Field of View (FOV) of 75 degrees
    // 	Set an Apsect Ratio of the inner width divided by the inner height of the window
    //	Set the 'Near' distance at which the camera will start rendering scene objects to 2
    //	Set the 'Far' (draw distance) at which objects will not be rendered to 1000
    this.camera = new THREE.PerspectiveCamera(
      80,
      window.innerWidth / window.innerHeight,
      1,
      5000
    );
    // this.camera.position.y = 10;
    //30 , 300 ,50

    this.camera.rotation.y = (45 / 180) * Math.PI;
    this.camera.position.x = 0;
    this.camera.position.y = 0.5;
    this.camera.position.z = 10; // origin: 50
    // this.camera.lookAt(0, 0, 20);
    // this.camera.up.set(0, 0, 1);

    //
    this.scene = new THREE.Scene();
    // this.scene.background = new THREE.Color(0xfffff4);
    //

    // this.scene.background = new THREE.Color(0xd8e1e7);
    // d8e1e7 soft blue ciel
    // this.scene.fog = new THREE.Fog(0xcce0ff, 500, 10000);
    //
    //
    // ---------------------------------------
    //                  RENDERER
    // ---------------------------------------
    //
    this.renderer = new THREE.WebGL1Renderer({
      antialias: true, // will make the edges smooth
      // set the transparency of the scene, otherwise its black
      alpha: true,
    });
    //
    //
    //
    this.renderer.setClearColor(0x000000, 0);
    //
    this.renderer.setSize(width, height);
    // BG color from the scene

    //
    //
    //

    this.renderer.shadowMap.type = THREE.PCFSoftShadowMap;
    // showMap is connected to the shadows in any object/model
    this.renderer.shadowMap.enabled = true;
    this.renderer.shadowMap.autoUpdate = true;
    //

    // NEW -- REALISTIC LIGHT
    // https://redstapler.co/three-js-realistic-material-reflection-tutorial/
    this.renderer.toneMapping = THREE.ACESFilmicToneMapping;
    this.renderer.toneMappingExposure = 1.25; //0.1 will show it darker, 2 is exremely hight

    //
    // here you append it to the jsx
    this.monteCacaoOne.appendChild(this.renderer.domElement); // mount using React ref

    //

    //
    // OrbitControls allow a camera to orbit around the object
    // https://threejs.org/docs/#examples/controls/OrbitControls
    this.controls = new OrbitControls(this.camera, this.monteCacaoOne);
    //  ------------- **

    //

    //  to limit zoom distance so that the User
    //  dont zoom out of the specified range

    this.controls.maxDistance = 12;
    this.controls.minDistance = 8.8; //3 will aproach you more into the scene // 6 will not allow you to get that close into the scene
  };
  /*
    this.controls.maxDistance = 10;
    this.controls.minDistance = 3; //3 will aproach you more into the scene // 6 will not allow you to get that close into the scene

  

                             addCustomSceneObjects = () => {



   
  */

  // 2
  addCustomSceneObjects = () => {
    //
    //
    //              ---------------------   *
    //                materials
    //           *  ---------------------
    //

    //------------------------------

    //
    const gltfLoader = new GLTFLoader(this.manager);
    const dracoLoader = new DRACOLoader();
    dracoLoader.setDecoderPath("myDecoder/");
    gltfLoader.setDRACOLoader(dracoLoader);
    // //
    this.loaderImg = new THREE.TextureLoader();
    // //

    // -------------------------------------------
    //  STUDIO ENV MAP  ** it works
    let textureEquirec;
    // https://github.com/mrdoob/three.js/blob/master/examples/webgl_materials_envmaps.html
    // this.envMap = this.loaderImg.load("./envMap/studio_envMap.jpg");
    // this.envMap.mapping = THREE.SphericalReflectionMapping();
    // material.envMap = envMap;
    this.loaderImgCube = new THREE.CubeTextureLoader();
    this.loaderImgCube.setPath("./img/bridge_cube_img/");

    this.textiCubeEnvBridge = this.loaderImgCube.load([
      "posx.jpg",
      "negx.jpg",
      "posy.jpg",
      "negy.jpg",
      "posz.jpg",
      "negz.jpg",
    ]);

    this.textiCubeEnvBridge.encoding = THREE.sRGBEncoding;

    //
    /*
    
       new RGBELoader()
      .setPath("./img/")
      .load("photo_studio_01_4k.hdr", function (hdrmap) {});

    
    */
    //
    const textureLoader = new THREE.TextureLoader();
    textureEquirec = textureLoader.load("./img/envMap/studio_envMap.jpg");
    textureEquirec.mapping = THREE.EquirectangularReflectionMapping;
    textureEquirec.encoding = THREE.sRGBEncoding;
    //
    // environment
    // PMREMGenerator: Prefilteres, Midmapped Radiance Environment Map
    const pmremGenerator = new THREE.PMREMGenerator(this.renderer);
    pmremGenerator.compileEquirectangularShader();
    // SCENE BACKGROUND ///)))))))---------------------***
    // https://stackoverflow.com/questions/61712628/threejs-how-to-add-hdri-equirectangle-map-for-lighting-the-scene-while-keepi
    // this.scene.background = new THREE.Color(0xFEF5E9);

    // this.scene.background = this.textiCubeEnvBridge;
    // this.scene.environment = this.textiCubeEnvBridge;
    this.scene.environment = pmremGenerator.fromScene(
      new RoomEnvironment(),
      0.02
    ).textureEquirec;
    // //

    //
    // STEEL BRIDGE REFLECTION
    this.SteelBridgeMat = new THREE.MeshLambertMaterial({
      envMap: this.textiCubeEnvBridge,
      color: 0xeeeeee,
    });
    // STEEL BLACK
    this.SteelBlackBridgeMat = new THREE.MeshLambertMaterial({
      envMap: this.textiCubeEnvBridge,
      // DONT ADD 000000 as its too dark and will not shine, instead add a lower shade of black
      color: 0x0c0c0c,
    });
    //
    //
    /*
    
    
    
      // this.bodyCrocoPink.repeat.set(-0.1, -0.1);
    //stretch it LG extrem // this.bodyCrocoPink.repeat.set(0.1, 0.1);
    // https://stackoverflow.com/questions/33803280/three-js-how-do-i-scaling-and-offset-my-image-textures

    
    
    
    */
    // -------------------------------------------

    // CROCO GREEN
    this.bodyCroco = this.loaderImg.load(
      "./img/medium_smallSquaresCroco____.png"
    );

    this.crocoMatPhysical = new THREE.MeshPhysicalMaterial({
      //color: 0x0b0b0b, //green olive dark   //this.renderer.toneMappingExposure = 3;  you must to go up to check this
      // color: 0xc19800, //green acid light  //this.renderer.toneMappingExposure = 3;  you must to go up to check this
      //color: 0xc19800, //green olive light  //this.renderer.toneMappingExposure = 0.8;  you must to go up to check this
      color: 0xa8620f, //tamarindo  //this.renderer.toneMappingExposure = 3;  you must to go up to check this
      //color: 0xC68402, //tamarindo  //this.renderer.toneMappingExposure = 0.8;  you must to go up to check this
      //
      emissive: 0x000000,
      // metalness: 0.1,
      flatShading: false, //true : you will see more faces of the model, to false. its reduced
      roughness: 0, //extremely shine: VINYL
      // clearcoat: 150, // clearcoat: and clearcoatRoughness:  is more like a real lether glowing
      // clearcoatRoughness: 0,
      side: THREE.DoubleSide,
      map: this.bodyCroco,
      reflectivity: 1, // not allowed in MeshStandardMaterial
    });
    //
    /*
    
    
    
    
    


*/

    // -------------------------------------------
    //                COLORS
    // -------------------------------------------
    //
    gltfLoader.load("./models_furniture/barcelonaChair_good2.glb", (gltf) => {
      gltf.scene.traverse((itemsBarcelonaChair) => {
        this.meshToPlayWithAnimation = gltf.scene;

        //
        //       //
        if (itemsBarcelonaChair.name === "cushion_bort") {
          itemsBarcelonaChair.material = this.crocoMatPhysical;
          itemsBarcelonaChair.position.y = 0.1;
        }
        //
        if (itemsBarcelonaChair.name === "cushionbort2") {
          itemsBarcelonaChair.material = this.crocoMatPhysical;
          itemsBarcelonaChair.position.y = 0.1;
        }
        //
        if (itemsBarcelonaChair.name === "steel_chair") {
          itemsBarcelonaChair.material = this.SteelBridgeMat;
          itemsBarcelonaChair.position.y = 0.1;
        }
        //--------------------------
        //
        if (itemsBarcelonaChair.name === "blackRubberFeetChair_left_bottom") {
          itemsBarcelonaChair.material = this.SteelBlackBridgeMat;
          itemsBarcelonaChair.position.y = 0.1;
        }
        if (itemsBarcelonaChair.name === "blackRubberFeetChair_right_bottom") {
          itemsBarcelonaChair.material = this.SteelBlackBridgeMat;
          itemsBarcelonaChair.position.y = 0.1;
        }
        if (
          itemsBarcelonaChair.name === "blackRubberFeetChair_left_bottom_back"
        ) {
          itemsBarcelonaChair.material = this.SteelBlackBridgeMat;
          itemsBarcelonaChair.position.y = 0.1;
        }
        if (
          itemsBarcelonaChair.name === "blackRubberFeetChair_right_bottom_back"
        ) {
          itemsBarcelonaChair.material = this.SteelBlackBridgeMat;
          itemsBarcelonaChair.position.y = 0.1;
        }
        // --------------------------------
        //
        //
        if (itemsBarcelonaChair.name === "rubberFrontLeft") {
          itemsBarcelonaChair.material = this.SteelBlackBridgeMat;
          itemsBarcelonaChair.position.y = 0.1;
        }
        if (itemsBarcelonaChair.name === "rubberFrontRight") {
          itemsBarcelonaChair.material = this.SteelBlackBridgeMat;
          itemsBarcelonaChair.position.y = 0.1;
        }
        if (itemsBarcelonaChair.name === "rubberLeftBack") {
          itemsBarcelonaChair.material = this.SteelBlackBridgeMat;
          itemsBarcelonaChair.position.y = 0.1;
        }
        if (itemsBarcelonaChair.name === "rubberRightBack") {
          itemsBarcelonaChair.material = this.SteelBlackBridgeMat;
          itemsBarcelonaChair.position.y = 0.1;
        }
        //       //
        itemsBarcelonaChair.castShadow = true;
        // itemsBarcelonaChair.receiveShadow = true;

        //----------------------------**
        // console.log( itemsBarcelonaChair);
      });

      this.scene.add(gltf.scene);
      this.SteelBridgeMat.dispose();
      this.crocoMatPhysical.dispose();
    });
    //
    //              ---------------------   *
    //                     CHAIR
    //           *  ---------------------
    //

    //
    //
    //

    //

    /*
















*/
    //

    // //
    // //Floor
    // //-----------------
    // //  PLANE / FLOOR
    // //-----------------
    // //
    this.planeGeometry = new THREE.PlaneGeometry(20, 20, 3, 3);
    // creating the material that will make the plane transparent and will keep the shadow:
    // https://stackoverflow.com/questions/40783127/transparent-shadow-in-three-js
    this.matTranspmaterial = new THREE.ShadowMaterial({ opacity: 0.5 });
    this.matTranspmaterial.opacity = 0.1; //0.5 the shadow will be darker, o.1 lower
    //
    this.planeMesh = new THREE.Mesh(this.planeGeometry, this.matTranspmaterial);
    this.planeMesh.rotateX(-Math.PI / 2);
    this.planeMesh.position.y = -2.39;
    this.planeMesh.receiveShadow = true;
    this.planeMesh.position.x = 0;
    this.planeMesh.position.z = 0;
    //
    this.scene.add(this.planeMesh);

    /*
    











    
    
    
    

  
    
                    -----------------------------
    
  
    
                      ***   LIGHTS ***
    
    different light test

                    -----------------------------                
                    
                    
                    
                    
                    
                    
 */
    // ------------------------------

    //---------------------------------
    //
    // ------------------------------
    // light of the car example
    //
    // this.hLight = new THREE.AmbientLight(0xfff7e2, 2, 100);
    // this.scene.add(this.hLight);

    // //
    // //
    // this.directionalLight = new THREE.DirectionalLight(0xfff7e2, 2, 100);
    // this.directionalLight.position.set(0, 20, 0);
    // this.directionalLight.castShadow = true;
    // this.scene.add(this.directionalLight);

    //
    //spotlights
    this.light = new THREE.PointLight(0xc4c4c4, 1);
    this.light.position.set(0, 300, 500);
    this.scene.add(this.light);
    //
    this.light2 = new THREE.PointLight(0xc4c4c4, 2);
    this.light2.position.set(500, 100, 0);
    this.scene.add(this.light2);
    // //
    this.light3 = new THREE.PointLight(0xc4c4c4, 2);
    this.light3.position.set(0, 100, -500);
    this.scene.add(this.light3);
    // //
    this.light4 = new THREE.PointLight(0xc4c4c4, 1);
    this.light4.position.set(-500, 300, 0);
    this.scene.add(this.light4);

    //---------------------------------
    /*








*/
    //-------------------------------------
    //                        NEW TEST
    //   SecondHemLight
    //------------------
    // https://www.youtube.com/watch?v=T6PhV4Hz0u4&list=PLIQopnnM5nVaHWcPUWL6wPrQvBUTQZK1X&index=22
    // https://threejs.org/docs/#api/en/lights/RectAreaLight
    // https://threejsfundamentals.org/threejs/lessons/threejs-lights.html
    //https://discourse.threejs.org/t/degree-or-radian/21227/2

    //
    //---------------------
    //  This hemisphere light will give light to the top and bottom of the chair
    //---------------------
    this.upColor = 0xffff80;
    this.downColor = 0x40400ff;

    this.SecondHemLight = new THREE.HemisphereLight(
      this.upColor,
      this.downColor,
      1
    );
    this.scene.add(this.SecondHemLight);

    //helper
    // const sphereSecondHemLight = 1;
    // const spotSecondHemLight = new THREE.PointLightHelper(
    //   this.SecondHemLight,
    //   sphereSecondHemLight
    // );
    // this.scene.add(spotSecondHemLight);
    //
    //----------------------------------
    // THIS LIGHT IS SIMILAR TO THE BLENDER ONE, the one that can be long
    //----------------------------------
    //
    //
    this.widthLightRectArea = 20;
    this.heightLightRectArea = 20;

    // RectAreaLightUniformsLib.init();  this one goes at the very top of the page
    // THREE.RectAreaLightUniformsLib.init();
    this.lightRectArea = new THREE.RectAreaLight(
      0xffffff,
      4,
      this.widthLightRectArea,
      this.heightLightRectArea
    );

    this.lightRectArea.position.set(0, 10, 0);
    // this.lightRectArea.rotation.x = THREE.MathUtils.degToRad(-32);
    this.lightRectArea.lookAt(0, 0, 0);
    //
    this.scene.add(this.lightRectArea);
    // const helper = new RectAreaLightHelper(this.lightRectArea);
    // this.lightRectArea.add(helper);
    // -------------------------------------
    /*
 





*/
    // //                       THE SUN
    // // its the distance that gives the shadow
    this.spotLight = new THREE.SpotLight(0xfff7e2, 2, 100);
    this.spotLight.position.set(0, 20, 0);
    this.spotLight.castShadow = true;
    this.spotLight.shadow.bias = -0.0001;
    this.spotLight.shadow.mapSize.width = 1024 * 4;
    this.spotLight.shadow.mapSize.height = 1024 * 4;
    this.scene.add(this.spotLight);
    //
    //helper
    // const sphereSpotLight = 0.2;
    // const spotLightHelper = new THREE.PointLightHelper(
    //   this.spotLight,
    //   sphereSpotLight
    // );
    // this.scene.add(spotLightHelper);

    //
    this.light.dispose();
    this.light2.dispose();
    this.light3.dispose();
    this.light4.dispose();
    this.SecondHemLight.dispose();
    this.lightRectArea.dispose();
    this.spotLight.dispose();

    /*
    
    
    
    
    
    
    
    
    */
    //--------------------------
    //
    //--------------------------
    //          Clock
    //
    this.clock = new THREE.Clock();
    this.clock2 = new THREE.Clock();
    this.delta = 0;
    this.delta2 = 0;
    // 30 fps
    this.interval = 1 / 30;
    this.time2 = 0.002;
    //
    //
  };

  /*









                            startAnimationLoop = () => {



                              

   
  */
  //spotLight
  // 3
  startAnimationLoop = () => {
    // ------------------
    // Will rotate the chair
    // ------------------
    if (this.meshToPlayWithAnimation) {
      this.meshToPlayWithAnimation.rotation.y += this.time2 = 0.002;
      // ----------
      // this.meshToPlayWithAnimation.position.x =  15 + Math.abs(Math.sin(this.time2 * 0.5)) * 80;
    }
    // ------------------
    // LIGHT ANIMATION will mimic the sun movement during the day
    // ------------------
    // this.lightRectArea.position.set(
    //   // this is a trick to simulate a real world dynamic LIGHT SOURCES
    //   this.camera.position.x + 2,
    //   this.camera.position.y + 5,
    //   this.camera.position.z + 2
    //   // when i add 10 to the 3 coordinates it will give me a thin line under the chair cuchion
    // );

    this.requestID = window.requestAnimationFrame(this.startAnimationLoop);

    this.prevTime = this.time;
    this.renderer.render(this.scene, this.camera);
  };

  /*




                             handleWindowResize = ()



   
  */

  handleWindowResize = () => {
    const width = this.monteCacaoOne.clientWidth;
    const height = this.monteCacaoOne.clientHeight;

    // updated renderer
    this.renderer.setSize(width, height);
    // updated **camera** aspect ratio
    this.camera.aspect = width / height;
    // That is the Three.js optimization: you can group multiple camera changes into a block with only one
    this.camera.updateProjectionMatrix();
  };
  /*


  */

  render() {
    return (
      <div
        className="chairBox_three"
        ref={(ref) => (this.monteCacaoOne = ref)}
      ></div>
    );
  }
}

export default FurnitureThreeScene;
